import { render, staticRenderFns } from "./HeroParallax.vue?vue&type=template&id=715d23fe&"
import script from "./HeroParallax.vue?vue&type=script&lang=js&"
export * from "./HeroParallax.vue?vue&type=script&lang=js&"
import style0 from "./HeroParallax.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports